export { default } from './GoogleRatingCard'
